<template>
    <div class="yx-center">
        <div>4 0 1</div>
        <div>您没有权限进入此页面</div>
        <el-button type="primary" @click="goHome"  style="margin-top: 30px">返回首页</el-button>
    </div>
</template>

<script>
export default {
    name: "noAccess",
    methods: {
        goHome () {
            this.$store.dispatch("setUserInfo", null)
            this.$store.dispatch("setUser", null)
            window.location.href = window.location.pathname
        }
    }
}
</script>

<style scoped lang="less">
.yx-center {
    height: 100vh;
    font-size: 30px;
}
</style>
